// @flow

// A type safe assignment from a partial record containing modifications to an exact record
export default function exactMerge<R: { ... }, M: Partial<R>>(
  record: R,
  modifications: M
): R {
  return Object.assign(({}: any), record, modifications);
}
